module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e11200ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Levelbar.vue
// module id = 232
// module chunks = 17